import type { Dispatch, SetStateAction } from "react";
import { GiConfigurationForAddNewViewTab } from "../../../../data-model/giConfigDetails";

interface HandleConfigTextChangeParams {
  nextText: string;
  setConfigText: Dispatch<SetStateAction<string>>;
  setConfigError: Dispatch<SetStateAction<string | null>>;
  setGiConfiguration: Dispatch<SetStateAction<GiConfigurationForAddNewViewTab>>;
}

/**
 * Updates JSON editor text and synchronizes parsed configuration state.
 * If the JSON is invalid, keeps the text value and updates the error message.
 */
export const handleConfigTextChange = ({
  nextText,
  setConfigText,
  setConfigError,
  setGiConfiguration,
}: HandleConfigTextChangeParams) => {
  setConfigText(nextText);
  try {
    const parsed = JSON.parse(nextText);
    setConfigError(null);
    setGiConfiguration((prev) => ({
      ...prev,
      config: parsed,
    }));
  } catch (error) {
    setConfigError(error instanceof Error ? error.message : "Invalid JSON");
  }
};
